<template>
	<div>
		<div class="subSectionTitleWithoutborder">
			<span>📱 Télécharger l'application</span>
		</div>
		<a target="_blank" href="https://apps.apple.com/us/app/orthographiq/id6470994772">
			<p>iPhone : App store</p>
		</a>
		<a
			target="_blank"
			href="https://play.google.com/store/apps/details?id=com.orthographiq.app.twa&pcampaignid=web_share"
		>
			<p>Android : Google Play Store</p>
		</a>
	</div>
</template>

<script>
export default {
	name: 'WhereToDownloadApp',
};
</script>

<style scoped>
.subSectionTitleWithoutborder {
	font-weight: bold;
	margin-bottom: 30px;
	color: grey;
}
</style>
